import { render, staticRenderFns } from "./EditPDPage.vue?vue&type=template&id=2a35640b&"
import script from "./EditPDPage.vue?vue&type=script&lang=js&"
export * from "./EditPDPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports